import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import GroupUsersIcon from 'icons/GroupUsers.icon';
import TruckIcon from 'icons/Truck.icon';
import TrashIcon from 'icons/Trash.icon';
import PencilIcon from 'icons/Pencil.icon';
import DownloadIcon from 'icons/Download.icon';
import DataRoomSelectedDocumentsContext from '../../providers/DataRoomSelectedDocuments/DataRoomSelectedDocuments.context';
import ActionMenu from 'components/ActionMenu';
import { useTranslation } from 'react-i18next';
import LinkIcon from 'icons/Link.icon';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import useToastPositionCalculate from './hooks/useToastPositionCalculate';

import './DataRoomActionMenu.styles.scss';
import './DataRoomActionMenu.styles.responsive.scss';

type DataRoomActionMenuProps = {
  className?: string;
  onClose: () => void;
  onMove: () => void;
  onDelete: () => void;
  onRename: () => void;
  onDownload: () => void;
  onManage: () => void;
  onShareFiles: () => void;
};

const DataRoomActionMenu: React.FC<DataRoomActionMenuProps> = (props) => {
  const {
    className,
    onMove,
    onManage,
    onClose,
    onDelete,
    onRename,
    onDownload,
    onShareFiles,
  } = props;

  const { canUserCreateShareableLinks } = useContext(DataRoomContext);
  const {
    selected,
    selectedLabel,
    canShareFiles,
    shouldRename,
    shouldAllowBulkActions,
    hasAuthorizedActionsForAllSelected,
    canDownloadSelected,
  } = useContext(DataRoomSelectedDocumentsContext);

  const classes = classNames('data-room-action-menu', className);

  const { t } = useTranslation();
  const { top } = useToastPositionCalculate();

  const actions = useMemo(
    () => [
      ...(canShareFiles
        ? [
            {
              onClick: onManage,
              icon: <GroupUsersIcon strokeWidth={2} />,
            },
          ]
        : []),
      ...(canShareFiles && canUserCreateShareableLinks
        ? [
            {
              onClick: onShareFiles,
              icon: LinkIcon,
            },
          ]
        : []),
      ...(hasAuthorizedActionsForAllSelected
        ? [
            {
              onClick: onMove,
              icon: TruckIcon,
            },
          ]
        : []),
      ...(shouldRename
        ? [
            {
              onClick: onRename,
              icon: PencilIcon,
            },
          ]
        : []),
      ...(canDownloadSelected
        ? [
            {
              onClick: onDownload,
              icon: DownloadIcon,
            },
          ]
        : []),
      ...(hasAuthorizedActionsForAllSelected
        ? [
            {
              alert: true,
              onClick: onDelete,
              icon: TrashIcon,
            },
          ]
        : []),
    ],
    [
      hasAuthorizedActionsForAllSelected,
      shouldRename,
      canDownloadSelected,
      canUserCreateShareableLinks,
      canShareFiles,
      onDelete,
      onDownload,
      onManage,
      onMove,
      onRename,
      onShareFiles,
    ],
  );

  if (!shouldAllowBulkActions || !actions.length) return null;

  return (
    <ActionMenu
      className={classes}
      label={t(selectedLabel, { count: selected.length })}
      actions={actions}
      position={{ top }}
      onClose={onClose}
    />
  );
};

export default DataRoomActionMenu;
